import { createRoleThunks } from "./roleSliceFactory";
import { AGENT_ENDPOINTS, ROLE_COLLECTION_KEYS } from "../types/roles";

const slice = createRoleThunks(
  "agent",
  AGENT_ENDPOINTS,
  ROLE_COLLECTION_KEYS.agent
);

export const agentThunks = {
  fetchResource: slice.fetchResource,
  createResource: slice.createResource,
  updateResource: slice.updateResource,
  runAction: slice.runAction,
};

export const agentActions = slice.actions;

export default slice.reducer;
